export var ObjectEditorType;
(function (ObjectEditorType) {
    ObjectEditorType[ObjectEditorType["AboveProperties"] = 0] = "AboveProperties";
    ObjectEditorType[ObjectEditorType["BelowProperties"] = 1] = "BelowProperties";
    ObjectEditorType[ObjectEditorType["InsteadOfProperties"] = 2] = "InsteadOfProperties";
    ObjectEditorType[ObjectEditorType["OnInitialCreate"] = 3] = "OnInitialCreate";
    ObjectEditorType[ObjectEditorType["AsPrimaryAction"] = 4] = "AsPrimaryAction";
})(ObjectEditorType || (ObjectEditorType = {}));
;
